

<template>
    <BModal :model-value="modal" scrollable size="lg" centered title="Package" @update:modelValue="updateModal" >
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Package</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="updateModal(false)"
                >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <BTabs content-class="mt-3" v-model="tabIndex" >
            <BTab title="Detail">
                    <BRow class="mb-3">
                        <BCol>
                            <BFormInput placeholder="Package Name"></BFormInput>
                        </BCol>
                    </BRow>

                    <BRow class="mb-3">
                        <BCol class="d-flex">
                            
                            <p class='mr-2 mt-1' style="white-space: nowrap;">Pax :</p>
                            <BFormInput  type="number" ></BFormInput>
                            
                        </BCol>
                        <BCol class="d-flex">
                            <p class='mr-2 mt-1' style="white-space: nowrap;">Duration :</p>
                            <BFormInput type="number" v-model="tabDetail.pax" placeholder="Duration (Day)"></BFormInput>
                        </BCol>
                    </BRow>

                    <BRow class="mb-3">
                        <BCol>
                            <BFormInput type="number" placeholder="Price"></BFormInput>
                        </BCol>
                    </BRow>
            </BTab>

            <BTab title="Programs">
                <BRow  v-for="i in parseInt(tabDetail.pax)" :key="i" class="mb-3">
                    <BCol cols="1" class="text-right">
                        <span>Day-{{ i }}</span>
                    </BCol>
                    <BCol cols="11">
                        <BFormSelect :options="optionProgram"></BFormSelect>
                    </BCol>
                </BRow>
                <BRow v-if="tabDetail.pax === 0">
                    <h6 class="text-secondary py-3">Harap Masukkan Jumlah Pax Pada Tab Detail</h6>
                </BRow>
            </BTab>

            <BTab title="Inclusion & Exclusion">
                <BRow class="mb-3">
                    <BCol>
                        <label for="">Inclusions</label>
                        <BFormTextarea placeholder="Inclusion"></BFormTextarea>
                    </BCol>
                </BRow>
                <BRow >
                    <BCol>
                        <label for="">Exclusions</label>
                        <BFormTextarea placeholder="Exclusion"></BFormTextarea>
                    </BCol>
                </BRow>
            </BTab>
        </BTabs>
        
        <template #footer>
            <div class="d-flex justify-content-end">
                <!-- <BButton variant="danger" @click="$emit('updateModal', false)">Cancel</BButton> -->
                <BButton :disabled="tabIndex > 0 ? false : true" variant="secondary" @click="tabIndex--"  class="mr-2">Prev</BButton>
                <BButton v-if="tabIndex !== 2 " variant="primary" @click="tabIndex++"  class="mr-2">Next</BButton>
                <BButton v-if="tabIndex === 2 " variant="primary"  class="mr-2">Save</BButton>
                
            </div>
        </template>
    </BModal>
</template>

<script >     
import { BModal, BButton, BTabs, BTab, BRow, BCol, BFormInput, BFormSelect, BFormTextarea } from 'bootstrap-vue-next';
import { ref, reactive} from 'vue'


export default{
    name : 'PackageForm',
    props : {
        modal: Boolean,
    },
    components : {
        BModal, BButton, BTabs, BTab, BRow, BCol, BFormInput, BFormSelect, BFormTextarea
    },
    emits: ["update:modal"],
    setup(props, {emit}){
        const tabIndex = ref(0)
        
        // Tab Detail 
        const tabDetail  = reactive({
            pax : 0
        })

        // Tab Programs 
        const tabPrograms = reactive({
            
        })
        

        const updateModal = (value) => {
            emit("update:modal", value); // Sync modal state with parent
        };

        // dummy Option
        const optionProgram = ref([
            {value : 'none ', text : 'Pilih Program'},
            {value : 'program-1 ', text : 'program-1'},
            {value : 'program-2 ', text : 'program-2'},
            {value : 'program-3 ', text : 'program-3'},
        ])

        return {
            tabDetail,
            tabPrograms,
            updateModal,
            optionProgram,
            tabIndex
            
        }
    }
}


</script>

